import StepRequestMethod from './StepRequestMethod.component';

export default StepRequestMethod;
